// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1onUK","choiceBoxes":"toolbarselects_choiceBoxes__MrKw8","simpleField":"toolbarselects_simpleField__2EEYY"};